import { create } from "./API";

export const CreatePlatforms = async (payload: any) => {
  try {
    return await create(`${process.env.REACT_APP_API_URL}/platforms`, payload);
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
